import { rem } from '../../../utils/rem';
export var MuiDialogActions = {
    styleOverrides: {
        root: {
            padding: "".concat(rem(12), " ").concat(rem(24), " ").concat(rem(24)),
        },
    },
};
